import { render, staticRenderFns } from "./PersonelList.vue?vue&type=template&id=19e35dce&scoped=true&"
import script from "./PersonelList.vue?vue&type=script&lang=js&"
export * from "./PersonelList.vue?vue&type=script&lang=js&"
import style0 from "./PersonelList.vue?vue&type=style&index=0&id=19e35dce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e35dce",
  null
  
)

export default component.exports